import { isGradebookV2ActiveSelector } from '../selectors/search-gradebook';
import { getGradebook, getGradebookInstructor } from './getGradebook';
import { toggleShowFilterOptionsGradebook } from './filter';
import { updateAllAverages } from './averages';

export const applyGradebookFilters = (courseId) => (dispatch, getState) => {
  const state = getState();
  const {
    gradebook: { exceptionGroups, filterTypes, searchDateFrom, searchDateTo },
  } = state;
  const isGradebookV2Active = isGradebookV2ActiveSelector(state);

  if (isGradebookV2Active) {
    const options = {
      page: 1,
      exceptionGroupIds: exceptionGroups.map((group) => group.groupId),
      filterTypes,
    };

    if (searchDateFrom && searchDateTo) {
      options.searchDateFrom = searchDateFrom;
      options.searchDateTo = searchDateTo;
    }

    dispatch(getGradebookInstructor(courseId, options));
  } else {
    dispatch(getGradebook(courseId, { page: 1 }));
    dispatch(updateAllAverages());
  }

  dispatch(toggleShowFilterOptionsGradebook());
};
